import React from 'react';
import { IconProps } from '.';

const SvgCategoryLife = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} fillRule='evenodd' d='M4.25 3.25h15.5V9h-1.5V4.75H5.75V9h-1.5V3.25Z' clipRule='evenodd' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M2.25 8.25h5.4v5h8.7v-5h5.4v7.84c0 1.484-1.224 2.66-2.7 2.66H4.95c-1.476 0-2.7-1.176-2.7-2.66V8.25Zm1.5 1.5v6.34c0 .626.522 1.16 1.2 1.16h14.1c.678 0 1.2-.534 1.2-1.16V9.75h-2.4v5H6.15v-5h-2.4Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='M6.75 18v3h-1.5v-3h1.5ZM18.75 18v3h-1.5v-3h1.5Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgCategoryLife;
